<template>
    <div class="page-content g9">
        <Accord title="Materials">

            <Accord title="Supply amounts">
                <Tabs :menu="['Total DUN', 'Total Primary Packaging', 'DUN per Subject','Primary Packaging per Subject']">
                    <div class="tab">
                        <LineChart chart-name="supplyTotalDun" :settings="supplyTotalDunSettings"></LineChart>
                    </div>                   
                    <div class="tab">
                        <LineChart chart-name="supplyPackaging" :settings="supplyPackagingSettings"></LineChart>
                    </div>                   
                    <div class="tab">
                        <LineChart chart-name="supplyDunSubject"
                                   :settings="supplyDunSubjectSettings"
                                   :multiple="false"></LineChart>
                    </div>
                   <div class="tab">
                       <LineChart chart-name="supplyPackagingSubject"
                                  :settings="supplyPackagingSubjectSettings"
                                  :multiple="false"></LineChart>
                   </div>
                  
               </Tabs>
           </Accord>

           <Accord title="Ancillary amount">
               <LineChart chart-name="ancillaryAmount"
                          :multiple="true"
                          :settings="ancillaryAmountSettings"></LineChart>
           </Accord>

         <CanShowChart chart-name="Enrolment.SiteAncillaries">
             <Accord title="Site Ancillary">
               <LineChart chart-name="siteAncillaries"
                          :multiple="true"
                          :settings="siteAncillariesSettings"></LineChart>
               <button class="right" v-on:click="onDownloadSiteAncillaryClick">Download to excel</button>
             </Accord>
         </CanShowChart>
           <CanShowChart chart-name="Simulation.Batch">
               <Accord title="Packaging Campaigns">
                   <LineChart chart-name="packagingCampaignNew" :settings="packagingCampaignsSettings" :is-gantt="true"></LineChart>
                   <button class="right"  v-on:click="onDownloadProductionPlanClick">Download packaging plan</button>
               </Accord>
           </CanShowChart>
           <CanShowChart chart-name="Simulation.Stock">
               <Accord title="Stock Level">
                   <Tabs :menu="['Site', 'Depot']">
                       <div class="tab">
                           <LineChart chart-name="stockSiteNew" :multiple="{ DUN: false, Site: true }" :settings="stockSettings"></LineChart>
                       </div>
                       <div class="tab">
                           <LineChart chart-name="stockDepotNew" :multiple="{ DUN: false, Depot: true }" :settings="stockSettings"></LineChart>
                       </div>
                   </Tabs>
                   <div style="float:right" v-if="isSuperAdmin()">
                       <select v-model="selectedDispensingUnits" multiple="true">
                           <option v-for="option in dispensingUnits" v-bind:value="option.id">
                               {{option.name}}
                           </option>
                       </select>
                       <select v-model="selectedLocations" multiple="true">
                           <option v-for="option in locations" v-bind:value="option.id">
                               {{option.name}}
                           </option>
                       </select>
                       <div>
                           <button v-on:click="onDownloadStockClick" class="right">Download stock list</button>
                       </div>
                   </div>
               </Accord>
           </CanShowChart>
           <Accord title="Cost">
               <Tabs :menu="['DUN', 'API', 'Ancillary']">
                   <div class="tab">
                       <LineChart chart-name="costDun" :settings="costSettings"></LineChart>
                   </div>
                   <div class="tab">
                       <LineChart chart-name="costApi" :settings="costSettings"></LineChart>
                   </div>
                   <div class="tab">
                       <LineChart chart-name="costAncillary" :settings="costSettings"></LineChart>
                   </div>
               </Tabs>
           </Accord>

       </Accord>
   </div>
</template>

<script>
   import Accord from "../../Accord.vue"
   import LineChart from "../Charts/LineChart.vue"
   import CanShowChart from "../Charts/CanShowChart.vue"
   import Tabs from "../../Tabs.vue"
   import API from "../../../../Api"
   export default {
       components: {
           Accord,
           LineChart,
           Tabs,
           CanShowChart
       },
       data: function () {
           return {
               dispensingUnits: [],
               selectedDispensingUnits: [],
               locations: [],
               selectedLocations: [],
               cancelToken: null
           };
       },
       mounted: function () {
           this.populateDunList();
           this.populateLocationList();
       },
       methods: {
           isSuperAdmin() {
               return this.$store.state.member.isSuperAdmin;
           },
           populateDunList() {                
               let url = "forecast/GetDispensingUnits?forecastId=" + this.$route.params.id;
               
               this.cancelToken = API.CancelToken.source();
               
               return API.get(url, {
                   cancelToken: this.cancelToken.token
               }).then((res) => {

                   if (res.data) {
                       
                       this.dispensingUnits = res.data;
                   }
                   }
                 );
           },
           populateLocationList() {

               let url = "forecast/GetLocations?forecastId=" + this.$route.params.id;
               
               this.cancelToken = API.CancelToken.source();
               //debugger;
               return API.get(url, {
                   cancelToken: this.cancelToken.token
               }).then((res) => {

                   if (res.data) {
                       
                       this.locations = res.data;
                   }
               }
               );
           },
           onDownloadSiteAncillaryClick()
           {
               window.open("/api/download/SiteAncillaries?id=" + this.$route.params.id);
           },
           onDownloadStockClick() {                
               window.open("/api/download/Stock?id=" + this.$route.params.id + "&filterLocations=" + this.selectedLocations + "&filterDuns=" + this.selectedDispensingUnits)
           },
           onDownloadProductionPlanClick() {
               window.open("/api/download/ProductionPlan?id=" + this.$route.params.id)
           },
           supplyTotalDunSettings(data) {
               let chart = this.cloneObject(this.$store.state.dataView.chartDefaults);
               chart.chart = {
                   type: "column"
               };
               chart.legend.reversed = true;
               chart.series = data.series;
               chart.xAxis.categories = data.categories;
               chart.yAxis.title.text = "DUN";

               chart.tooltip = {
                   useHTML: true,
                   headerFormat: '<span style="color: {series.color}">{series.name} </span><table>',
                   pointFormatter: function () {
                       return this.series.name === 'Packaging'
                           ? '<tr><td>Total</td><td style="text-align: right"><b>' + this.real.toLocaleString() + '</b></td></tr>'
                           : '<tr><td>Total</td><td style="text-align: right"><b>' + this.real.toLocaleString() + '</b></td></tr>' +
                           '<tr><td>Surplus</td><td style="text-align: right"><b>' + this.percentage.toLocaleString() + ' %</b></td></tr>';
                   },
                   footerFormat: '</table>'
               };

               return chart;
           },
           supplyPackagingSettings(data) {
               let chart = this.cloneObject(this.$store.state.dataView.chartDefaults);
               chart.chart = {
                   type: "column"
               };
               chart.legend.reversed = true;
               chart.series = data.series;
               chart.xAxis.categories = data.categories;                
               chart.yAxis.title.text = "Primary Packaging";

               chart.tooltip = {
                   useHTML: true,
                   headerFormat: '<span style="color: {series.color}">{series.name} </span><table>',
                   pointFormatter: function () {
                       return this.series.name === "Exact"
                           ? '<tr><td>Primary Package total</td><td style="text-align: right"><b>' + this.packageTotal.toLocaleString() + '</b></td></tr>' +
                           '<tr><td>Dosage form total</td><td style="text-align: right"><b>' + this.formTotal.toLocaleString() + ' ' + this.unit + '</b></td></tr>' +
                           '<tr><td>API total</td><td style="text-align: right"><b>' + this.api.toLocaleString() + ' ' + this.apiUnit + '</b></td></tr>'
                           : '<tr><td>Primary Package total</td><td style="text-align: right"><b>' + this.packageTotal.toLocaleString() + '</b></td></tr>' +
                           '<tr><td>Dosage form total</td><td style="text-align: right"><b>' + this.formTotal.toLocaleString() + ' ' + this.unit + '</b></td></tr>' +
                           '<tr><td>API total</td><td style="text-align: right"><b>' + this.api.toLocaleString() + ' ' + this.apiUnit + '</b></td></tr>' +
                           '<tr><td>Surplus</td><td style="text-align: right"><b>' + this.percentage.toLocaleString() + ' %</b></td></tr>';
                   },
                   footerFormat: '</table>'
               };

               return chart;
           },
           supplyDunSubjectSettings(data) {
               let chart = this.cloneObject(this.$store.state.dataView.chartDefaults);
               chart.chart = {
                   type: "column"
               };
               chart.legend.reversed = true;
               chart.series = data.series;
               chart.xAxis.categories = data.categories;
               chart.yAxis.title.text = "DUN";
               chart.tooltip = {
                   useHTML: true,
                   headerFormat: '<span style="color: {series.color}">{series.name} </span><table>',
                   pointFormatter: function () {
                       return this.series.name === 'Packaging'
                           ? '<tr><td>Total</td><td style="text-align: right"><b>' + this.real.toLocaleString() + '</b></td></tr>'
                           : '<tr><td>Total</td><td style="text-align: right"><b>' + this.real.toLocaleString() + '</b></td></tr>' +
                           '<tr><td>Surplus</td><td style="text-align: right"><b>' + this.percentage.toLocaleString() + ' %</b></td></tr>';
                   },
                   footerFormat: '</table>'
               };

               return chart;
           },
           supplyPackagingSubjectSettings(data) {
               let chart = this.cloneObject(this.$store.state.dataView.chartDefaults);
               chart.chart = {
                   type: "column"
               };
               chart.legend.reversed = true;
               chart.tooltip = {
                   useHTML: true,
                   headerFormat: '<span style="color: {series.color}">{series.name} </span><table>',
                   pointFormatter: function () {
                       return this.series.name === 'Exact'
                           ? '<tr><td>Primary Package total</td><td style="text-align: right"><b>' + this.packageTotal.toLocaleString() + '</b></td></tr>' +
                           '<tr><td>Dosage form total</td><td style="text-align: right"><b>' + this.formTotal.toLocaleString() + ' ' + this.unit + '</b></td></tr>' +
                           '<tr><td>API total</td><td style="text-align: right"><b>' + this.api.toLocaleString() + ' ' + this.apiUnit + '</b></td></tr>' 
                           : '<tr><td>Primary Package total</td><td style="text-align: right"><b>' + this.packageTotal.toLocaleString() + '</b></td></tr>' +
                           '<tr><td>Dosage form total</td><td style="text-align: right"><b>' + this.formTotal.toLocaleString() + ' ' + this.unit + '</b></td></tr>' +
                           '<tr><td>API total</td><td style="text-align: right"><b>' + this.api.toLocaleString() + ' ' + this.apiUnit + '</b></td></tr>' +
                           '<tr><td>Surplus</td><td style="text-align: right"><b>' + this.percentage.toLocaleString() + ' %</b></td></tr>';
                   },
                   footerFormat: '</table>'
               };

               chart.series = data.series;
               chart.xAxis.categories = data.categories;
               chart.yAxis.title.text = "Primary Packaging";

               return chart;
           },
           siteAncillariesSettings(data)
           {
             //test
             console.log("Site ancillaries graph settings initialized");
             const thisRef = this;
              
             const chartDefaults = this.$store.state.dataView.chartDefaults;
             chartDefaults.plotOptions.line.marker.enabled = true;
             let chart = thisRef.cloneObject(chartDefaults);
             chart.chart = {
               type: "line",
               zoomType: "x",
             };
             chart.series = data.series;
             chart.xAxis.type = "datetime";
             chart.yAxis.title.text = "No of Ancillaries";
             chart.xAxis.title.text = "Date";

             chart.tooltip = {
               useHTML: true,
               headerFormat: '<span style="color: {series.color}"><b>{series.name}</b></span><table>',
               pointFormatter: function () {

                 let dateRow = '<tr><td><b>Date</b>: '+ this.shortDate.toLocaleString() + '</td></tr>';
                 let headerRow1 = '<tr><td><b>Accumulated quantity:</b> '+ this.y.toLocaleString() + '</td></tr>';
                 let headerRow2 = '<tr><td><b>Accumulated cost:</b> '+ this.cost.toLocaleString() + '</td></tr>';
                 
                 return dateRow + headerRow1 + headerRow2;
               },
               footerFormat: '</table>'
             };

             return chart;
           },
           ancillaryAmountSettings(data) {
               let chart = this.cloneObject(this.$store.state.dataView.chartDefaults);
               chart.chart = {
                   type: "column"
               };
               chart.legend.reversed = true;
               chart.series = data.series;
               chart.xAxis.categories = data.categories;
               chart.yAxis.title.text = "Unit";
               chart.tooltip = {
                   useHTML: true,
                   headerFormat: '<span style="color: {series.color}">{series.name} </span><table>',
                   pointFormatter: function () {
                       return this.series.name === 'Packaging'
             ? '<tr><td>Total</td><td style="text-align: right"><b>' + this.y.toLocaleString() + '</b></td></tr>'
             : '<tr><td>Total</td><td style="text-align: right"><b>' + this.y.toLocaleString() + '</b></td></tr>' +
                           '<tr><td>Surplus</td><td style="text-align: right"><b>' + this.percentage.toLocaleString() + ' %</b></td></tr>';
                   },
                   footerFormat: '</table>',
               };

               return chart;
           },

           packagingCampaignsSettings(data) {
               let chart = {
                   type: "gantt",
                   legend: {
                       align: "left",
                       verticalAlign: "top",
                       borderWidth: 0
                   },
                   title: {
                       text: null
                   },
                   xAxis: [{
                       type: "datetime",
                       cropThreshold: Number.MAX_VALUE,
                       labels: {
                           style: {
                               fontSize: "10px;"
                           },
                           format: "{value:%b}"
                       },                                              
                   }, {
                     tickInterval: 1000 * 60 * 60 * 24 * 365, // Year
                     labels: {
                       format: '{value:%Y}',
                       style: {
                         fontSize: '10px'
                       }
                     },
                     linkedTo: 0
                   }],
                   yAxis: {
                       uniqueNames: true,
                       cropThreshold: Number.MAX_VALUE,
                                           
                   },
                   navigator: {
                       enabled: true,
                       liveRedraw: true,
                       series: {
                           type: "gantt",
                           pointPlacement: 0.5,
                           pointPadding: 0.25
                       },
                       yAxis: {
                           reversed: true,
                           categories: []
                       }
                   },
                   scrollbar: {
                       enabled: true
                   },
                   rangeSelector: {
                       enabled: true,
                       selected: 6, // "All" - if rangeSelector.buttons is changed this should also be changed
                       buttonPosition: {
                           align: "left",
                           x: -50
                       }
                   },
                   credits: {
                       enabled: false
                   },
                   tooltip: {
                       useHTML: true,
                       headerFormat: '<span style="color: {series.color}">{series.name} </span>',
                       pointFormat: '' +
                           'Packaging start date: <b>{point.start:%d-%m-%Y}</b><br>' +
                           'Available / Release date: <b>{point.end:%d-%m-%Y}</b><br>' +
                           'Expiry date: <b>{point.expiry:%d-%m-%Y}</b><br>' +
                           'Batch / Lot size: <b>{point.batchSize:,.f}</b><br>' +
                           'Released to: <b>{point.releasedTo}</b><br>' +
                           'Expired DUN\'s from the batch: <b>{point.expired:,.f}</b><br>' +
                           'Remaining DUN\'s on stock: <b>{point.remaining:,.f}</b><br>' +
                           'Lot/batch type: <b>{point.type}</b><br>' +
                           'Lot/batch name: <b>{point.batchName}</b><br>',
                       footerFormat: '',
                       valueDecimals: 2
                   }
               };

               chart.series = data.series;

               return chart;
           },

           stockSettings(data) {
               let chart = this.cloneObject(this.$store.state.dataView.chartDefaults);
               chart.chart = {
                   type: "line",
                   zoomType: "x"
               };
               chart.series = data.series;
               chart.xAxis.type = "datetime";
               chart.yAxis.title.text = "DUN";
               chart.xAxis.title.text = "Date";

               return chart;
           },

           costSettings(data) {
               let chart = this.cloneObject(this.$store.state.dataView.chartDefaults);
               chart.chart = {
                   type: "column"
               };
               chart.legend.reversed = true;
               chart.series = data.series;
               chart.xAxis.categories = data.categories;
               chart.yAxis.title.text = this.$store.state.dataView.forecast.currency;
               chart.tooltip = {
                   useHTML: true,
                   headerFormat: '<span style="color: {series.color}">{series.name} </span><table>',
                   pointFormatter: function () {
                       return this.series.name === 'Packaging'
                           ? '<tr><td>Total</td><td style="text-align: right"><b>' + this.y.toLocaleString() + '</b></td></tr>'
                           : '<tr><td>Total</td><td style="text-align: right"><b>' + this.y.toLocaleString() + '</b></td></tr>' +
                           '<tr><td>Surplus</td><td style="text-align: right"><b>' + this.percentage.toLocaleString() + ' %</b></td></tr>';
                   },
                   footerFormat: '</table>',
               };

               return chart;
           },
       }
   }
</script>
